import { useContext, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

import './FAQ.css';
import { ArrowIcon } from '../../../assets/icons/icons';
import { getRandomId } from '../../../assets/utils/utils';
import { QUESTIONS } from '../../../assets/utils/constants';

function FAQ() {

    const [openItemId, setOpenItemId] = useState(QUESTIONS[0]._id);

    const toggleItem = (id) => {
        if (openItemId === id) {
            setOpenItemId(null);
        } else {
            setOpenItemId(id);
        }
    };

    return (
        <div className='faq'>
            <h4 className='faq__title'>Часто задаваемые вопросы</h4>
            <div className='faq__items'>
                {QUESTIONS.slice(0, 6).map((item, i) => (
                    <button className={`faq__item ${openItemId === item._id ? 'faq__item_selected' : ''}`} type='button' key={`faq__item${item._id}`} onClick={() => toggleItem(item._id)}>
                        <div className='faq__item-info'>
                            <p className='faq__item-info-question'
                                dangerouslySetInnerHTML={{
                                    __html: item.question,
                                }}
                            ></p>
                            <AnimatePresence mode='sync'>
                                {openItemId === item._id && (
                                    <motion.div
                                        initial={{ opacity: 0, height: 0, y: -20, }}
                                        animate={{ opacity: 1, height: 'auto', y: 0, }}
                                        exit={{ opacity: 0, height: 0, y: -20, }}
                                        transition={{ duration: 0.3 }}
                                    >
                                        <p className='faq__item-info-answer'
                                            dangerouslySetInnerHTML={{
                                                __html: item.answer,
                                            }}
                                        ></p>
                                    </motion.div>
                                )}
                            </AnimatePresence>
                        </div>
                        <ArrowIcon
                            mainClassName={'faq__item-arrow'}
                            fillClassName={'faq__item-arrow-fill'}
                        />
                    </button>
                ))}

            </div>
        </div>
    );
}

export default FAQ